import { useFormContext } from '@calendly/form'
import { useBooleanState, useOnValueChange } from '@calendly/hooks'
import { isEmpty, isNaN, isNumber } from 'lodash-es'

const isBlankValue = (value) => isEmpty(value) && (!isNumber(value) || isNaN(value))

export const useErrorAfterInitialTouch = (name) => {
  const {
    values: { [name]: value },
    errors: { [name]: error },
    setFieldError
  } = useFormContext()
  const [touched, setTouched] = useBooleanState(false)

  useOnValueChange(error, () => {
    if (touched) return
    if (!isBlankValue(value)) return
    if (isBlankValue(error)) return

    setFieldError(name, null)
    setTouched()
  })
}
